<template>
  <md-modal-dialog v-slot="{
    title,
    message,
    important,
    confirmText,
    cancelText,
    confirmDisabled = false,
    cancelDisabled = false,
    confirmButtonColor = 'md-primary',
    cancelButtonColor = 'md-primary'
  }"
  :md-close-on-esc="false"
  :md-click-outside-to-close="false">

    <md-dialog-title>{{ title }}</md-dialog-title>
    <md-dialog-content>
      <span style="font-weight: bold">
        {{ important }}
      </span>
      <p v-html="message"></p>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button :class="[cancelButtonColor, 'md-flat']" @click="onCancel" :disabled="cancelDisabled" v-if="cancelText">{{cancelText}}</md-button>
      <md-button :class="[confirmButtonColor, 'md-flat']" @click="onConfirm" :disabled="confirmDisabled" v-if="confirmText">{{confirmText}}</md-button>
    </md-dialog-actions>

  </md-modal-dialog>
</template>

<script>

import ValidatedInputs from '@/components/ValidatedInput';
import { LoginCard } from "@/components";

export default {
  components: {
    ...ValidatedInputs,
  },
  methods: {
    onCancel(){
      this.$modal.submit(false);
    },
    onConfirm(){
      this.confirmDisabled = true;
      this.$modal.submit(true);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/theme.scss";

.md-subheader {
  padding: 0px;
}

</style>
